import React from 'react';
import { Phone, Bot, TestTube, Rocket } from 'lucide-react';

const Process = () => {
  const steps = [
    {
      icon: Phone,
      title: "Discovery Call",
      description: "We learn about your business, customers, and main challenges. Quick 15-minute call to understand exactly what you need.",
      days: "Day 1",
      duration: "15 min call"
    },
    {
      icon: Bot,
      title: "Build Your Assistant", 
      description: "We create your AI chatbot with your brand voice and business knowledge. Trained on your products, services, and common questions.",
      days: "Days 2-7",
      duration: "6 days"
    },
    {
      icon: TestTube,
      title: "Test & Perfect",
      description: "We test with real customer scenarios and fine-tune responses. Make sure it handles your specific situations perfectly.",
      days: "Days 8-9", 
      duration: "2 days"
    },
    {
      icon: Rocket,
      title: "Go Live",
      description: "Deploy on your website, WhatsApp, or phone system. We train your team and monitor everything works smoothly.",
      days: "Day 10",
      duration: "Same day"
    }
  ];

  return (
    <section id="process" className="section process-section">
      <div className="process-background">
        <div className="geometric-line line-1"></div>
        <div className="geometric-line line-2"></div>
        <div className="geometric-line line-3"></div>
        <div className="geometric-line line-4"></div>
        <div className="geometric-line line-5"></div>
        <div className="geometric-line line-6"></div>
        <div className="geometric-line line-7"></div>
        <div className="geometric-line line-8"></div>
        <div className="geometric-line line-9"></div>
        <div className="geometric-line line-10"></div>
        <div className="geometric-line line-11"></div>
        <div className="geometric-line line-12"></div>
        <div className="geometric-line line-13"></div>
        <div className="geometric-line line-14"></div>
        <div className="geometric-line line-15"></div>
        <div className="automation-text text-1">Processing request...</div>
        <div className="automation-text text-2">AI analyzing...</div>
        <div className="automation-text text-3">Generating response...</div>
        <div className="automation-text text-4">Message sent</div>
        <div className="automation-text text-5">Customer satisfied</div>
        <div className="automation-text text-6">Connecting to database...</div>
        <div className="automation-text text-7">Webhook triggered</div>
        <div className="automation-text text-8">Task completed</div>
      </div>
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">How we build your AI assistant</h2>
          <p className="section-subtitle">
            From strategy to deployment in 10 days. Our proven process ensures your AI assistant 
            delivers exceptional results from day one.
          </p>
        </div>
        <div className="process-timeline">
          {steps.map((step, index) => {
            const IconComponent = step.icon;
            return (
              <div key={index} className="process-step" data-step={index + 1}>
                <div className="step-number">{index + 1}</div>
                <div className="step-content">
                <div className="step-header">
                  <div className="title-with-icon">
                    <div className="step-icon">
                      <IconComponent size={16} />
                    </div>
                    <h3>{step.title}</h3>
                  </div>
                  <div className="step-timing">
                    <span className="step-days">{step.days}</span>
                    <span className="step-duration">{step.duration}</span>
                  </div>
                </div>
                <p>{step.description}</p>
                <div className="step-progress">
                  <div className="progress-bar"></div>
                </div>
              </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;